import type { UsersSettingsResponse } from '@customerio/hydra-ui-api';

/**
 * Per-user, per-environment UI settings — the legacy users-settings blob
 * behind `/v1/accounts/{account_id}/users/{id}/settings/{env_id}`: saved list
 * columns (`people_page`, `campaigns_page`), delivery/performance channel
 * picks, and dashboard segment ids. Wire shape end-to-end; the GET always
 * returns every field, defaulting the ones the user never set.
 */
export type UserEnvSettings = UsersSettingsResponse;

export const userEnvSettingsKeys = {
  all: ['user-env-settings'] as const,
  detail: (accountId: number, userId: number, workspaceId: number) =>
    ['user-env-settings', accountId, userId, workspaceId] as const,
};
